import { render, staticRenderFns } from "./CheckBoxRed.vue?vue&type=template&id=74c8154c&scoped=true"
import script from "./CheckBoxRed.vue?vue&type=script&lang=js"
export * from "./CheckBoxRed.vue?vue&type=script&lang=js"
import style0 from "./CheckBoxRed.vue?vue&type=style&index=0&id=74c8154c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c8154c",
  null
  
)

export default component.exports